import styles from './FJLeftPanelHeader.module.less';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import FJArrowBack from '../../../assets/svg/back.svg?react';

const FJLeftPanelHeader = props => {
    const { text, className, onClick } = props;
    return (
        <div className={classNames(styles.box, className)}>
            <FJArrowBack className={styles.header_title_back} onClick={onClick} />
            <div className={styles.header_text}>{text}</div>
        </div>
    );
};

FJLeftPanelHeader.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

export default FJLeftPanelHeader;
